/** @format */

import React, { useState } from 'react';
import { Col } from 'antd';
import { formatLeadId, validateLeadId } from '../../../utils/leadIdValidator';

interface MemberPreliminaryInfoProps {
  request: boolean;
  dependents: boolean;
  status: 'single' | 'married';
  leadId: string;
  onRequestChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDependentsChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onStatusChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onLeadIdChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const MemberPreliminaryInfo: React.FC<MemberPreliminaryInfoProps> = ({
  request,
  dependents,
  status,
  leadId,
  onRequestChange,
  onDependentsChange,
  onStatusChange,
  onLeadIdChange,
}) => {
  const [leadIdError, setLeadIdError] = useState<string | null>(null);

  const handleLeadIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const originalValue = e.target.value;
    const formattedValue = formatLeadId(originalValue);
    
    // Check if characters were removed (invalid input detected)
    if (originalValue !== formattedValue && originalValue !== '') {
      setLeadIdError('Lead ID must contain only digits, please have your manager refer you to the video tutorial on where to find it on convoso.');
    } else {
      setLeadIdError(null);
    }
    
    e.target.value = formattedValue;
    onLeadIdChange(e);
  };
  return (
    <>
      <Col sm={24} md={24} lg={24} xl={24}>
        <div className='form-heading'>
          <span>Member Preliminary Information</span>
        </div>
      </Col>

      {/* Lead ID */}
      <Col sm={24} md={24} lg={24} xl={24}>
        <div className='form-input-wrapper'>
          <label>Lead ID *</label>
          <input
            type='text'
            name='leadId'
            value={leadId}
            onChange={handleLeadIdChange}
            required
          />
          {leadIdError && <span style={{ color: 'red', fontSize: '12px' }}>{leadIdError}</span>}
        </div>
      </Col>

      {/* ACA Request */}
      <Col sm={24} md={24} lg={24} xl={24}>
        <div className='radial-input'>
          <label>Does this form include an ACA request? *</label>
          <div className='radial-input-wrapper'>
            <label>
              <input
                type='radio'
                name='request'
                value='true'
                checked={request === true}
                onChange={onRequestChange}
              />
              Yes
            </label>
            <label>
              <input
                type='radio'
                name='request'
                value='false'
                checked={request === false}
                onChange={onRequestChange}
              />
              No
            </label>
          </div>
        </div>
      </Col>

      {/* Dependents - Only show when ACA request is true */}
      {request && (
        <Col sm={24} md={24} lg={24} xl={24}>
          <div className='radial-input'>
            <label>Does the member have any dependents?*</label>
            <div className='radial-input-wrapper'>
              <label>
                <input
                  type='radio'
                  name='dependents'
                  value='true'
                  checked={dependents === true}
                  onChange={onDependentsChange}
                />
                Yes
              </label>
              <label>
                <input
                  type='radio'
                  name='dependents'
                  value='false'
                  checked={dependents === false}
                  onChange={onDependentsChange}
                />
                No
              </label>
            </div>
          </div>
        </Col>
      )}

      {/* Marital Status - Only show when ACA request is true */}
      {request && (
        <Col sm={24} md={24} lg={24} xl={24}>
          <div className='radial-input'>
            <label>Marital Status *</label>
            <div className='radial-input-wrapper'>
              <label>
                <input
                  type='radio'
                  name='status'
                  value='single'
                  checked={status === 'single'}
                  onChange={onStatusChange}
                />
                Single
              </label>
              <label>
                <input
                  type='radio'
                  name='status'
                  value='married'
                  checked={status === 'married'}
                  onChange={onStatusChange}
                />
                Married
              </label>
            </div>
          </div>
        </Col>
      )}
    </>
  );
};
